import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import cn from "classnames";
import { Add } from "@icons/Add";
import { Remove } from "@icons/Remove";
import { useWindow } from "@hooks/useWindow";
export const Accordion = (props) => {
    const myWindow = useWindow();
    const { accordionItems, accordionClassName, useRichTextContent = false, ...rest } = props;
    const [accordion, setAccordion] = useState(accordionItems);
    const [activeHash, setActiveHash] = useState();
    const toggleAccordionHash = (index) => {
        toggleAccordion(index);
        toggleHash(index);
    };
    const toggleAccordion = (index) => {
        setAccordion((prevState) => prevState.map((accordionItem, idx) => ({ ...accordionItem, isOpen: index === idx ? !accordionItem.isOpen : accordionItem.isOpen })));
    };
    const toggleHash = useCallback((index) => {
        if (myWindow) {
            const accordionId = accordion[index].id;
            const isHashMatching = myWindow.location.hash.split("#")[1] === accordionId;
            const hash = !isHashMatching && !!accordionId ? accordionId : "";
            if (!!hash) {
                window.location.hash = hash;
            }
            else {
                myWindow.history.replaceState(null, null, " ");
            }
        }
    }, [myWindow]);
    const hashChangeListener = useCallback(() => {
        const hashValue = window.location.hash && window.location.hash.split("#")[1];
        if (!!hashValue) {
            setActiveHash(hashValue);
        }
    }, [activeHash]);
    useEffect(() => {
        if (!!myWindow) {
            hashChangeListener();
            myWindow.addEventListener("hashchange", function () {
                hashChangeListener();
            });
        }
    }, [myWindow]);
    useEffect(() => {
        if (!!activeHash) {
            setAccordion((prevState) => prevState.map((accordionItem) => ({ ...accordionItem, isOpen: accordionItem.id === activeHash })));
        }
    }, [activeHash]);
    useEffect(() => {
        setAccordion(accordionItems);
    }, [accordionItems]);
    const accordionRef = useRef([]);
    return (_jsx("div", { ...rest, children: accordion.map((item, idx) => {
            var _a, _b;
            return (_jsxs("div", { className: "relative", ...(item.id ? { id: item.id } : {}), children: [_jsxs("button", { className: cn("accordion", accordionClassName, { "border-t": idx === 0, "accordion--open": item.isOpen }), onClick: () => toggleAccordionHash(idx), children: [_jsx("h2", { className: "accordion__title", children: item.title }), _jsx("span", { className: "accordion__button", children: item.isOpen ? _jsx(Remove, {}) : _jsx(Add, {}) })] }), _jsx("div", { ref: (ref) => (accordionRef.current[idx] = ref), className: cn("accordion__content", { "accordion__content--open": item.isOpen, "accordion__content--rich-text": useRichTextContent }), style: {
                            height: item.isOpen ? (_a = accordionRef.current[idx]) === null || _a === void 0 ? void 0 : _a.scrollHeight : "0px",
                            overflowY: item.isOpen && ((_b = accordionRef.current[idx]) === null || _b === void 0 ? void 0 : _b.scrollHeight) > 500 ? "scroll" : "hidden"
                        }, children: useRichTextContent ? _jsx("div", { dangerouslySetInnerHTML: { __html: item.content } }) : _jsx("div", { children: item.content }) })] }, idx));
        }) }));
};
